const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trade Globally, Seamlessly, and Securely</h1>
        <p>
          Power, precision, and performance, in your pocket.

          {/* Whether you’re hedging against inflation or capitalizing on short-term
          price shifts, The Pips provides an intuitive platform for both
          precision and performance. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
